module.exports = __webpack_public_path__ + "static/img/02344_9.76914da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/02344_9.jpg
// module id = CWTW
// module chunks = 1